// extracted by mini-css-extract-plugin
export default {"addUser__addIcon":"styles_addUser__addIcon__kmKB2","resendInviteBtn":"styles_resendInviteBtn__i7Eul"};